module.exports = __webpack_public_path__ + "static/media/wspolpracaco0.b89a92cb.svg";